import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule, MatCardModule, MatChipsModule,
  MatDatepickerModule, MatDialogModule,
  MatDividerModule,
  MatFormFieldModule, MatIcon, MatIconModule,
  MatInputModule, MatProgressBarModule,
  MatSelectModule,
  MatSlideToggleModule
} from '@angular/material';
import { UiErrorsModule } from '@ui/ui-errors';
import { UploadDocumentPhotoModule } from '@ui/upload-document-photo';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';

import { RenterRegistrationComponent } from '@core/components/components/renter-registration/renter-registration.component';
import { RenterAddTransportComponent } from '@core/components/components/renter-add-transport/renter-add-transport.component';
import { RenterDrivingLicenseComponent } from '@core/components/components/renter-driving-license/renter-driving-license.component';
import { RenterPassportComponent } from '@core/components/components/renter-passport/renter-passport.component';
import { RenterRentBannedComponent} from "@core/components/components/renter-rent-banned/renter-rent-banned.component";
import { FieldPhoneNumberInputModule } from '@ui/field-phone-number-input';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { DurationRentInputComponent } from '@core/components/components/duration-rent-input/duration-rent-input.component';
import { ModalTrailerDefectComponent } from '@core/components/components/modal-trailer-defect/modal-trailer-defect.component';
import { InputImagesModule } from '@ui/input-images/input-images.module';
import { TrailerDefectsComponent } from '@core/components/components/trailer-defects/trailer-defects.component';
import { NgxMaskModule } from 'ngx-mask';
import { ModalAddTractionCarComponent } from '@core/components/components/modal-add-traction-car/modal-add-traction-car.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import { IdCardComponent } from './components/id-card/id-card.component';
import { RenterIdentificationDocument } from './components/renter-identification-document/renter-identification-document.component';

@NgModule({
  declarations: [
    RenterAddTransportComponent,
    RenterDrivingLicenseComponent,
    RenterIdentificationDocument,
    RenterPassportComponent,
    RenterRentBannedComponent,
    RenterRegistrationComponent,
    DurationRentInputComponent,
    ModalTrailerDefectComponent,
    TrailerDefectsComponent,
    ModalAddTractionCarComponent,
    IdCardComponent
  ],
  entryComponents: [
    ModalTrailerDefectComponent,
    ModalAddTractionCarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UiErrorsModule,
    UploadDocumentPhotoModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatProgressBarModule,
    MatChipsModule,
    InputImagesModule,
    FieldPhoneNumberInputModule,
    Angular2PromiseButtonModule.forRoot(),
    NgxMaskModule.forRoot(),
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDividerModule
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] }
  ],
  exports: [
    RenterAddTransportComponent,
    RenterDrivingLicenseComponent,
    RenterPassportComponent,
    RenterIdentificationDocument,
    RenterRegistrationComponent,
    DurationRentInputComponent,
    ModalTrailerDefectComponent,
    TrailerDefectsComponent,
    ModalAddTractionCarComponent,
    RenterRentBannedComponent,
    IdCardComponent
  ]
})
export class ComponentsModule { }
